window.StringUtil = function() {}

/**
 * Camel case로 변경.(첫글자 소문자로 시작)
 *
 * @param input 입력 문자열
 * @return 변형된 문자열
 */
window.StringUtil.toCamelCase = function(input) {
  return input.replace(/-/g, '_').replace(/(_\w)/g, function(m) {
    return m[1].toUpperCase()
  })
}

window.String.prototype.toCamelCase = function() {
  return window.StringUtil.toCamelCase(this)
}

window._autoResizeTextArea = function(text) {
  text.style.height = 'auto'
  text.style.height = text.scrollHeight + 'px'
}

/**
 * Snake case로 변경.(첫글자 소문자로 시작)
 *
 * @param input 입력 문자열
 * @return 변형된 문자열
 */
window.StringUtil.toSnakeCase = function(input) {
  return input
    .replace(/\.?([A-Z]+)/g, function(x, y) {
      return '_' + y.toLowerCase()
    })
    .replace(/^_/, '')
}

window.String.prototype.toSnakeCase = function() {
  return window.StringUtil.toSnakeCase(this)
}

/**
 * Pascal case로 변경.(첫글자 대문자로 시작)
 *
 * @param input 입력 문자열
 * @return 변형된 문자열
 */
window.StringUtil.toPascalCase = function(input) {
  input = window.StringUtil.toCamelCase(input)
  return input.substring(0, 1).toUpperCase() + input.substring(1)
}

window.String.prototype.toPascalCase = function() {
  return window.StringUtil.toPascalCase(this)
}

window.String.prototype.replaceAll = function(searchStr, replaceStr) {
  return this.split(searchStr).join(replaceStr)
}

const entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '`': '&#x60;',
  '=': '&#x3D;'
}
window.String.prototype.escapeHtml = function() {
  return String(this).replace(/[&<>"'`=]/g, function(s) {
    return entityMap[s]
  })
}

window.String.prototype.stripTags = function() {
  const doc = new DOMParser().parseFromString(this, 'text/html')
  return doc.body.textContent || ''
}

window.String.prototype.getShortContents = function(len) {
  if (len > this.length) {
    return this
  }
  return this.substring(0, len) + '...'
}
